(()=>{"use strict";const raf=callback=>window.requestAnimationFrame(()=>window.requestAnimationFrame(callback));function initGallery(gallery){if(gallery.dataset.seGalleryReady==="true")return;const viewer=gallery.querySelector('[id^="GalleryViewer"]'),thumbnailComponent=gallery.querySelector('[id^="GalleryThumbnails"]'),thumbnailItems=Array.from(gallery.querySelectorAll('[id^="Slider-Thumbnails"] > li[data-target]')),thumbnails=thumbnailItems.map(item=>item.querySelector("button")).filter(Boolean);if(!viewer||!thumbnails.length)return;gallery.dataset.seGalleryReady="true",gallery.classList.add("se-product-gallery-fixed");const total=thumbnails.length,currentNodes=gallery.querySelectorAll(".slider-counter--current"),totalNodes=gallery.querySelectorAll(".slider-counter--total"),status=gallery.querySelector('[id^="GalleryStatus"]');gallery.querySelectorAll(".slider-button--prev, .slider-button--next").forEach(button=>{button.hidden=!1,button.removeAttribute("aria-hidden")});const syncViewerHeight=()=>{if(!thumbnailComponent)return;const activeMedia=viewer.querySelector("[data-media-id].is-active")||viewer.querySelector("[data-media-id]"),height=Math.round((activeMedia||viewer).getBoundingClientRect().height);height>0&&gallery.style.setProperty("--se-gallery-viewer-height",`${height}px`)},sync=(announce=!1)=>{let index=thumbnails.findIndex(button=>button.getAttribute("aria-current")==="true");if(index<0){const active=viewer.querySelector("[data-media-id].is-active");active&&(index=thumbnailItems.findIndex(item=>item.dataset.target===active.dataset.mediaId))}index=Math.max(0,index),currentNodes.forEach(node=>{node.textContent=String(index+1)}),totalNodes.forEach(node=>{node.textContent=String(total)}),thumbnails.forEach((button,buttonIndex)=>{const isCurrent=buttonIndex===index;if(isCurrent){button.getAttribute("aria-current")!=="true"&&button.setAttribute("aria-current","true")}else button.hasAttribute("aria-current")&&button.removeAttribute("aria-current")}),announce&&status&&(status.removeAttribute("aria-hidden"),status.textContent=`Image ${index+1} of ${total}`),syncViewerHeight()};thumbnails.forEach(button=>button.addEventListener("click",()=>raf(()=>sync(!0)))),gallery.addEventListener("slideChanged",()=>raf(()=>sync(!0)));const selectionObserver=new MutationObserver(()=>raf(()=>sync(!1)));thumbnails.forEach(button=>selectionObserver.observe(button,{attributes:!0,attributeFilter:["aria-current"]})),"ResizeObserver"in window&&new ResizeObserver(syncViewerHeight).observe(viewer),sync(!1)}function initQuantity(root=document){root.querySelectorAll('input[name="quantity"]').forEach(input=>{if(input.dataset.seQuantityReady==="true")return;const wrapper=input.closest("quantity-input, .quantity")||input.parentElement,minus=wrapper?.querySelector('button[name="minus"], .quantity__button:first-of-type');if(!minus)return;input.dataset.seQuantityReady="true";const update=()=>{const minimum=Number.parseFloat(input.min||"1"),value=Number.parseFloat(input.value||String(minimum)),atMinimum=!Number.isFinite(value)||value<=minimum;minus.disabled=atMinimum,minus.setAttribute("aria-disabled",String(atMinimum))};["input","change"].forEach(eventName=>input.addEventListener(eventName,update)),wrapper.addEventListener("click",()=>window.setTimeout(update,0)),update()})}function trustifyHasContent(block){const container=block.querySelector(".trustify-review-stars, .trustify-review-box")||block;return container.children.length?!!(container.textContent.trim()||container.querySelector('svg, img, [class*="star"], [class*="review-item"], [data-review-id]')):!1}function syncTrustify(block){const fullReviews=!!block.querySelector(".trustify-review-box"),section=fullReviews&&block.closest(".shopify-section")||block,hasContent=trustifyHasContent(block);section.hidden=!hasContent,section.dataset.seTrustifyState=hasContent?"ready":"empty";let heading=section.previousElementSibling;heading?.classList?.contains("se-customer-reviews-heading")&&!hasContent&&heading.remove(),fullReviews&&hasContent&&!heading?.classList?.contains("se-customer-reviews-heading")&&(heading=document.createElement("h2"),heading.className="se-customer-reviews-heading",heading.textContent="Customer reviews",section.before(heading))}function initTrustify(root=document){root.querySelectorAll('[id^="shopify-block-"][id*="trustify" i]').forEach(block=>{if(block.dataset.seTrustifyReady==="true")return;block.dataset.seTrustifyReady="true",new MutationObserver(()=>syncTrustify(block)).observe(block,{childList:!0,subtree:!0,characterData:!0}),syncTrustify(block)})}function initRelatedCarousel(scroller){if(scroller.dataset.seCarouselReady==="true")return;const track=scroller.firstElementChild,cards=track?Array.from(track.children):[];if(cards.length<2)return;scroller.dataset.seCarouselReady="true",scroller.classList.add("se-related-carousel"),scroller.tabIndex=0,scroller.setAttribute("role","region"),scroller.setAttribute("aria-label","Related products carousel");const controls=document.createElement("div");controls.className="se-related-carousel__controls",controls.innerHTML='<button class="se-related-carousel__button se-related-carousel__prev" type="button" aria-label="Previous related products">\u2039</button><div class="se-related-carousel__progress" aria-hidden="true"><span></span></div><button class="se-related-carousel__button se-related-carousel__next" type="button" aria-label="Next related products">\u203A</button><span class="visually-hidden se-related-carousel__status" aria-live="polite"></span>',scroller.after(controls);const previous=controls.querySelector(".se-related-carousel__prev"),next=controls.querySelector(".se-related-carousel__next"),progress=controls.querySelector(".se-related-carousel__progress span"),status=controls.querySelector(".se-related-carousel__status"),update=()=>{const maximum=Math.max(0,scroller.scrollWidth-scroller.clientWidth),position=Math.min(maximum,Math.max(0,scroller.scrollLeft)),ratio=maximum?position/maximum:1;progress.style.transform=`scaleX(${ratio})`,previous.disabled=position<=2,next.disabled=position>=maximum-2,previous.setAttribute("aria-disabled",String(previous.disabled)),next.setAttribute("aria-disabled",String(next.disabled));const firstVisible=Math.min(cards.length,Math.max(1,Math.round(position/Math.max(1,cards[0].getBoundingClientRect().width))+1));status.textContent=`Showing related product ${firstVisible} of ${cards.length}`},move=direction=>{const gap=Number.parseFloat(getComputedStyle(track).columnGap||getComputedStyle(track).gap)||0,step=cards[0].getBoundingClientRect().width+gap;scroller.scrollBy({left:direction*step,behavior:"smooth"})};previous.addEventListener("click",()=>move(-1)),next.addEventListener("click",()=>move(1)),scroller.addEventListener("scroll",update,{passive:!0}),scroller.addEventListener("keydown",event=>{(event.key==="ArrowLeft"||event.key==="ArrowRight")&&(event.preventDefault(),move(event.key==="ArrowLeft"?-1:1))}),"ResizeObserver"in window&&new ResizeObserver(update).observe(scroller),update()}function init(root=document){root.querySelectorAll("media-gallery").forEach(initGallery),initQuantity(root),initTrustify(root),root.querySelectorAll('[class*="se-related-scroll-"]').forEach(initRelatedCarousel)}document.readyState==="loading"?document.addEventListener("DOMContentLoaded",()=>init()):init(),document.addEventListener("shopify:section:load",event=>init(event.target))})(),(()=>{if(window.__SE_PRODUCT_SCROLL_LOCK_GUARD__)return;window.__SE_PRODUCT_SCROLL_LOCK_GUARD__=!0;const lockClasses=["overflow-hidden","overflow-hidden-mobile","overflow-hidden-tablet","drawer--open","drawer--open-header","se-qv-lock","no-scroll","se-modal-lock"],activeOverlaySelector=["cart-drawer.active","modal-dialog[open]","product-modal[open]","details-modal details[open]","header-drawer details[open]","pickup-availability-drawer[open]","#se-quick-view-dialog.is-open"].join(","),isVisible=element=>{const style=window.getComputedStyle(element);return element.getClientRects().length>0&&style.display!=="none"&&style.visibility!=="hidden"},hasActiveOverlay=()=>Array.from(document.querySelectorAll(`${activeOverlaySelector}, dialog[open]`)).some(isVisible),clearHiddenOverflow=element=>{["overflow","overflow-y"].forEach(property=>{const value=element.style.getPropertyValue(property).trim();(value==="hidden"||value==="clip")&&element.style.removeProperty(property)})},releaseStaleLock=()=>{hasActiveOverlay()||(document.documentElement.classList.remove(...lockClasses),document.body.classList.remove(...lockClasses),clearHiddenOverflow(document.documentElement),clearHiddenOverflow(document.body))};let releaseTimer;const scheduleRelease=(delay=220)=>{window.clearTimeout(releaseTimer),releaseTimer=window.setTimeout(()=>{window.requestAnimationFrame(()=>window.requestAnimationFrame(releaseStaleLock))},delay)};new MutationObserver(()=>{(["overflow","overflow-y"].some(property=>{const value=document.body.style.getPropertyValue(property).trim();return value==="hidden"||value==="clip"})||lockClasses.some(name=>document.body.classList.contains(name)))&&scheduleRelease()}).observe(document.body,{attributes:!0,attributeFilter:["class","style"]}),["pageshow","popstate","modalClosed","shopify:section:load","shopify:section:unload"].forEach(eventName=>window.addEventListener(eventName,()=>scheduleRelease())),document.addEventListener("keyup",event=>{event.key==="Escape"&&scheduleRelease(360)}),document.addEventListener("click",event=>{event.target.closest?.(".modal__close-button, .drawer__close, .menu-drawer__close-button, .se-qv-close, .se-modal-close, [data-close]")&&scheduleRelease(420)},!0),scheduleRelease(320)})();
//# sourceMappingURL=/cdn/shop/t/104/assets/se-product-page-fixes.js.map?v=48636209750523312471787228308


/* Recover scroll when a drawer or modal leaves a stale document-level lock. */
(() => {
  if (window.__SE_PRODUCT_SCROLL_LOCK_GUARD_V2__) return;
  window.__SE_PRODUCT_SCROLL_LOCK_GUARD_V2__ = true;

  const lockClasses = [
    'overflow-hidden',
    'overflow-hidden-mobile',
    'overflow-hidden-tablet',
    'drawer--open',
    'drawer--open-header',
    'se-qv-lock',
    'no-scroll',
    'se-modal-lock',
  ];

  const overlaySelector = [
    'cart-drawer.active',
    'modal-dialog[open]:not(.popup-modal--closing)',
    'product-modal[open]',
    'details-modal details[open]',
    'header-drawer details[open].menu-opening',
    'pickup-availability-drawer[open]',
    '#se-quick-view-dialog.is-open',
    'dialog[open]',
  ].join(',');

  const isVisible = (element) => {
    const style = window.getComputedStyle(element);
    return (
      element.getClientRects().length > 0 &&
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      Number.parseFloat(style.opacity || '1') > 0
    );
  };

  const hasActiveOverlay = () =>
    Array.from(document.querySelectorAll(overlaySelector)).some(isVisible);

  const hasDocumentLock = () => {
    const roots = [document.documentElement, document.body].filter(Boolean);
    return roots.some((element) => {
      const inlineOverflow = ['overflow', 'overflow-x', 'overflow-y'].some((property) => {
        const value = element.style.getPropertyValue(property).trim();
        return value === 'hidden' || value === 'clip';
      });
      return (
        inlineOverflow ||
        element.style.getPropertyValue('touch-action').trim() === 'none' ||
        (element === document.body && element.style.position === 'fixed') ||
        lockClasses.some((name) => element.classList.contains(name))
      );
    });
  };

  const clearInlineLock = (element) => {
    ['overflow', 'overflow-x', 'overflow-y'].forEach((property) => {
      const value = element.style.getPropertyValue(property).trim();
      if (value === 'hidden' || value === 'clip') element.style.removeProperty(property);
    });
    if (element.style.getPropertyValue('touch-action').trim() === 'none') {
      element.style.removeProperty('touch-action');
    }
  };

  const clearFixedBodyLock = () => {
    if (document.body.style.position !== 'fixed') return;
    const top = Number.parseFloat(document.body.style.top || '0');
    ['position', 'top', 'left', 'right', 'width'].forEach((property) =>
      document.body.style.removeProperty(property),
    );
    if (Number.isFinite(top) && top < 0) window.scrollTo(0, Math.abs(top));
  };

  const releaseStaleLock = () => {
    if (!hasDocumentLock() || hasActiveOverlay()) return;
    document.documentElement.classList.remove(...lockClasses);
    document.body.classList.remove(...lockClasses);
    clearInlineLock(document.documentElement);
    clearInlineLock(document.body);
    clearFixedBodyLock();
  };

  let releaseTimer;
  const scheduleRelease = (delay = 180) => {
    window.clearTimeout(releaseTimer);
    releaseTimer = window.setTimeout(
      () => window.requestAnimationFrame(() => window.requestAnimationFrame(releaseStaleLock)),
      delay,
    );
  };

  const rootObserver = new MutationObserver((records) => {
    if (!hasDocumentLock()) return;
    if (
      records.some(({ target, attributeName }) =>
        target === document.body ||
        target === document.documentElement ||
        attributeName === 'open' ||
        target.matches?.(overlaySelector),
      )
    ) {
      scheduleRelease();
    }
  });

  rootObserver.observe(document.documentElement, {
    attributes: true,
    subtree: true,
    attributeFilter: ['class', 'style', 'open'],
  });

  ['DOMContentLoaded', 'load', 'pageshow', 'popstate', 'modalClosed', 'shopify:section:load', 'shopify:section:unload']
    .forEach((eventName) => window.addEventListener(eventName, () => scheduleRelease()));
  document.addEventListener('keyup', (event) => {
    if (event.key === 'Escape') scheduleRelease(360);
  });
  document.addEventListener(
    'click',
    (event) => {
      if (
        event.target.closest?.(
          '.modal__close-button, .product-media-modal__toggle, .drawer__close, .menu-drawer__close-button, .se-qv-close, .se-modal-close, [data-modal-close], [data-close]',
        )
      ) {
        scheduleRelease(420);
      }
    },
    true,
  );

  scheduleRelease(80);
  window.setTimeout(() => scheduleRelease(0), 800);
  window.setTimeout(() => scheduleRelease(0), 2600);
})();

/* Independent product gallery lightbox: no theme modal and no body scroll lock. */
(() => {
  if (window.__SE_PRODUCT_GALLERY_REBUILD__) return;
  window.__SE_PRODUCT_GALLERY_REBUILD__ = true;

  const style = document.createElement('style');
  style.id = 'se-product-gallery-rebuild-styles';
  style.textContent = `
    body.product-template media-gallery,
    body.product-template .product__media-wrapper,
    body.product-template .product__media-list,
    body.product-template .product__media-item,
    body.product-template .product__modal-opener,
    body.product-template .product__media-toggle {
      touch-action: pan-y pinch-zoom !important;
    }
    .se-product-lightbox[hidden] { display: none !important; }
    .se-product-lightbox {
      position: fixed;
      inset: 0;
      z-index: 100000;
      display: grid;
      place-items: center;
      padding: 20px;
      background: rgba(7, 23, 47, .88);
      box-sizing: border-box;
    }
    .se-product-lightbox__panel {
      position: relative;
      display: grid;
      place-items: center;
      width: min(100%, 1100px);
      height: min(90vh, 900px);
      padding: 54px 64px 32px;
      border-radius: 18px;
      background: #fff;
      box-shadow: 0 24px 80px rgba(0, 0, 0, .35);
      box-sizing: border-box;
    }
    .se-product-lightbox__image {
      display: block;
      max-width: 100%;
      max-height: calc(90vh - 100px);
      width: auto;
      height: auto;
      object-fit: contain;
    }
    .se-product-lightbox__close,
    .se-product-lightbox__previous,
    .se-product-lightbox__next {
      position: absolute;
      z-index: 2;
      display: grid;
      place-items: center;
      width: 44px;
      height: 44px;
      padding: 0;
      border: 1px solid rgba(7, 23, 47, .18);
      border-radius: 999px;
      background: #fff;
      color: #07172f;
      font: 700 28px/1 system-ui, sans-serif;
      cursor: pointer;
      box-shadow: 0 5px 18px rgba(7, 23, 47, .18);
    }
    .se-product-lightbox__close { top: 12px; right: 12px; }
    .se-product-lightbox__previous,
    .se-product-lightbox__next { top: 50%; transform: translateY(-50%); }
    .se-product-lightbox__previous { left: 12px; }
    .se-product-lightbox__next { right: 12px; }
    .se-product-lightbox__counter {
      position: absolute;
      left: 50%;
      bottom: 10px;
      transform: translateX(-50%);
      color: #334155;
      font: 700 14px/1.2 system-ui, sans-serif;
    }
    @media (max-width: 749px) {
      .se-product-lightbox { padding: 10px; }
      .se-product-lightbox__panel {
        width: 100%;
        height: min(88vh, 760px);
        padding: 52px 48px 34px;
        border-radius: 14px;
      }
      .se-product-lightbox__image { max-height: calc(88vh - 100px); }
      .se-product-lightbox__previous { left: 6px; }
      .se-product-lightbox__next { right: 6px; }
    }
  `;
  document.head.appendChild(style);

  let lightbox;
  let images = [];
  let currentIndex = 0;
  let openedBy;

  const updateLightbox = () => {
    if (!lightbox || !images.length) return;
    currentIndex = (currentIndex + images.length) % images.length;
    const source = images[currentIndex];
    const displayImage = lightbox.querySelector('.se-product-lightbox__image');
    displayImage.src = source.currentSrc || source.src;
    displayImage.alt = source.alt || 'Product image';
    lightbox.querySelector('.se-product-lightbox__counter').textContent =
      `${currentIndex + 1} of ${images.length}`;
    lightbox.querySelector('.se-product-lightbox__previous').hidden = images.length < 2;
    lightbox.querySelector('.se-product-lightbox__next').hidden = images.length < 2;
  };

  const closeLightbox = () => {
    if (!lightbox || lightbox.hidden) return;
    lightbox.hidden = true;
    lightbox.removeAttribute('data-open');
    openedBy?.focus?.();
  };

  const createLightbox = () => {
    if (lightbox) return lightbox;
    lightbox = document.createElement('div');
    lightbox.className = 'se-product-lightbox';
    lightbox.hidden = true;
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-label', 'Product images');
    lightbox.innerHTML = `
      <div class="se-product-lightbox__panel">
        <button type="button" class="se-product-lightbox__close" aria-label="Close product images">×</button>
        <button type="button" class="se-product-lightbox__previous" aria-label="Previous product image">‹</button>
        <img class="se-product-lightbox__image" alt="">
        <button type="button" class="se-product-lightbox__next" aria-label="Next product image">›</button>
        <span class="se-product-lightbox__counter" aria-live="polite"></span>
      </div>
    `;
    lightbox.addEventListener('click', (event) => {
      if (event.target === lightbox || event.target.closest('.se-product-lightbox__close')) {
        closeLightbox();
      } else if (event.target.closest('.se-product-lightbox__previous')) {
        currentIndex -= 1;
        updateLightbox();
      } else if (event.target.closest('.se-product-lightbox__next')) {
        currentIndex += 1;
        updateLightbox();
      }
    });
    document.body.appendChild(lightbox);
    return lightbox;
  };

  const rebuildGallery = (root = document) => {
    const galleries = root.querySelectorAll ? root.querySelectorAll('media-gallery') : [];
    galleries.forEach((gallery) => {
      if (gallery.dataset.seInteractionRebuilt === 'true') return;
      const openers = Array.from(
        gallery.querySelectorAll('modal-opener[data-modal^="#ProductModal-"]'),
      );
      if (!openers.length) return;

      gallery.dataset.seInteractionRebuilt = 'true';
      images = Array.from(gallery.querySelectorAll('.product__media-item img'));
      createLightbox();

      openers.forEach((opener, index) => {
        opener.dataset.seOriginalModal = opener.getAttribute('data-modal') || '';
        opener.removeAttribute('data-modal');
        const button = opener.querySelector('button:not(.product__media-toggle-play)');
        if (button) button.dataset.seLightboxIndex = String(index);
      });

      document
        .querySelectorAll('product-modal[id^="ProductModal-"], modal-dialog[id^="ProductModal-"]')
        .forEach((modal) => modal.remove());
    });
  };

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest?.('[data-se-lightbox-index]');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      openedBy = button;
      currentIndex = Number.parseInt(button.dataset.seLightboxIndex || '0', 10) || 0;
      createLightbox();
      updateLightbox();
      lightbox.hidden = false;
      lightbox.dataset.open = 'true';
      lightbox.querySelector('.se-product-lightbox__close').focus();
    },
    true,
  );

  document.addEventListener('keydown', (event) => {
    if (!lightbox || lightbox.hidden) return;
    if (event.key === 'Escape') closeLightbox();
    if (event.key === 'ArrowLeft') {
      currentIndex -= 1;
      updateLightbox();
    }
    if (event.key === 'ArrowRight') {
      currentIndex += 1;
      updateLightbox();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => rebuildGallery(), { once: true });
  } else {
    rebuildGallery();
  }
  document.addEventListener('shopify:section:load', (event) => rebuildGallery(event.target));
})();
